import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Row.scss';

interface RowProps {
  label?: ReactNode;
  value?: ReactNode;
  isTotal?: boolean;
}

export const Row: FC<RowProps> = ({
  label,
  value,
  isTotal = false
}) => {
  const rootClassNames = clsx(styles.root, {
    [styles.isTotal]: isTotal
  });

  return (
    <div className={rootClassNames}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};
